import { fetchProducts, fetchAddressSubscriptionProducts, fetchDomiciliationProductsAllAccounts } from '../actions/products'

export const loadProducts = async (dispatch, addressId = null) => {
  const queryStr = addressId ? `?addressId=${addressId}` : ''
  dispatch(fetchProducts([]))
  
  return fetch(`/api/products${queryStr}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(res => {
      return res.json()
    })
    .then(products => {
      dispatch(fetchProducts(products))
    })
}

export const loadAddressSubscriptionProducts = async (dispatch, addressId, options = {}) => {
  const query = []
  query.push(`addressId=${addressId}`)

  if (options.includeCreationOnboardingProduct) {
    query.push(`includeCreationOnboardingProduct=true`)
  }
  if (options.includeInactive) {
    query.push(`includeInactive=true`)
  }
  const queryStr = query.length > 0 ? `?${query.join('&')}` : ''

  dispatch(fetchAddressSubscriptionProducts(addressId, []))
  
  return fetch(`/api/products/address-subscriptions-products${queryStr}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(res => {
      return res.json()
    })
    .then(products => {
      dispatch(fetchAddressSubscriptionProducts(addressId, products))
    })
}

export const loadDomiciliationProductsAllAccounts = async (dispatch) => {
  dispatch(fetchDomiciliationProductsAllAccounts([]))

  return fetch(`/api/products/subscription-products-all-accounts`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(res => {
      return res.json()
    })
    .then(products => {
      dispatch(fetchDomiciliationProductsAllAccounts(products))
    })
}
